import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://majorappliancerepair.us";

// SEO component: sets title, meta description, canonical, OG tags, and optional JSON-LD.
export const SEO = ({
  title,
  description,
  path = "/",
  schema, // JSON-LD object or array of objects
}) => {
  const url = `${SITE_URL}${path}`;
  const schemas = schema
    ? Array.isArray(schema)
      ? schema
      : [schema]
    : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Major Appliance Repair NJ" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
